function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.643 8.148c-4.471.007-8.245 4.456-8.816 10.394-2.188-2.018-4.896-2.77-7.341-2.036-4.386 1.316-6.68 6.94-5.126 12.562a12.882 12.882 0 001.967 4.12c-3.06 2.36-3.636 7.389-1.331 11.633 2.146 3.95 6.171 6.065 9.603 5.043C20.93 52.326 27.315 49 27.315 49s6.387 4.545 11.054.51c1.155.59 2.515.905 3.907.906 3.862 0 6.993-3.59 6.993-6.516 0-1.089-.443-2.152-1.269-3.044a10.88 10.88 0 002.794-1.51c4.093-3.051 5.484-8.328 3.107-11.786-1.26-1.832-3.408-2.863-5.876-2.822.73-5.108-1.587-9.713-5.476-10.88-2.208-.662-4.642-.117-6.718 1.505-1.404-4.377-4.62-7.215-8.178-7.215h-.01zM7.091 34.589c2.072-2.21 4.71-2.905 7.451-3.326M35.831 15.363a11.288 11.288 0 00-2.129 6.651M42.218 29.046c1.008-2.133 1.78-4.444 5.807-4.308"
})), /*#__PURE__*/React.createElement("path", {
  d: "M26 53.3L27 36c-1.777-4.977-9.422-12.08-12-14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 31c2.086-5.141 2.618-10.858 2-17M27 36c3.143-5.59 6.431-10.474 10-14",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M31 53.3C32.082 43.843 35 39 44 30"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.3 44c3-3 7.663-4.816 10.7-4M34 42c-1-3-.097-4.992 2-10",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 53.3c-1-13-2-16.3-7-20.3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.4 42c-2.393-3.682-6.4-5-9.4-5M20.3 46c2.18-2.383 2.314-7.434 1.4-11",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}));

var SvgBush = function SvgBush(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBush, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bush.78ff061b.svg";
export { ForwardRef as ReactComponent };